module.exports = __webpack_public_path__ + "static/media/logout_icon.6345d1c6.png";